<div class="setup-bar">
  <div class="setup-bar-content">
    <img alt="SportsEngine"
      width="56px"
      height="14px"
      [src]="icon">
    <se-fe-header
      [seFeDataTitle]="seFeDataTitle"
      [seFeDataSize]="500">
    </se-fe-header>
    <se-po-progress-circle
      [percentage]="percentage">
    </se-po-progress-circle>
  </div>
</div>
